import { Component, HostListener, inject, OnInit } from '@angular/core';
import { UsersService } from './users.service';
import { CookieService } from "ngx-cookie-service";
import { NgForm } from '@angular/forms';
import { Dropdown } from 'primeng/dropdown';
import { decodeBase64ToText, encodeToBase64 } from '../../utility';
import { ToastService } from '../../shared/services/toast.service';
import { HelperService } from '../../shared/services/helper.service';
import { environment } from '../../../environments/environment';

interface DropDown {
  label?: string; // label can be a string or null
  value?: string; // value can be a string or null
}

interface Manager {
  user_id: string;
  name: string;
  email: string;
  gender?: string;
  avatar?: string | null;
  designation: string;
  manager_id: string;
  is_admin: string | boolean;
  is_affiliate: string | boolean;
  status: 'active' | 'inactive';
  groups: any[];
}

interface User {
  user_id: string;
  name: string;
  email?: string;
  gender?: DropDown;
  avatar?: string | null; // Use null if avatar can be absent
  designation?: DropDown | undefined;
  manager_object_id?: string;
  is_admin?: string | boolean; // Consider using boolean if applicable
  is_affiliate?: string | boolean; // Consider using boolean if applicable
  status?: boolean;
  manager_id: string;
  groups: any[];
  manager: any;

}

// interface Manager {
//   name: string;
// }

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
})
export class UsersComponent implements OnInit {
  isUserModalVisible:boolean=false
  users!: User[];
  visible: boolean = false;
  designations!: any[] | undefined;
  selectedDesignation: string | undefined;
  gender!: any[] | undefined;
  //manager: Manager[] | undefined;
  manager: any[] | any;
  user: any = {
    user_id: '',
    email: '',
    name: '',
    gender: {
      label: '',
      value: ''
    },
    designation: {
      label: null,
      value: null
    },
    manager_object_id: '',
    manager_id: '',
    groups: [],
    manager: {
      user_id: '',
      name: '',
      email: '',
      gender: '',
      avatar: '',
      designation: '',
      manager_id: '',
      is_admin: '',
      is_affiliate: '',
      groups: [],
      status: true
    },
    status:true
  };
  options: any[] = []; // Options for dropdown
  is_iel: boolean = false;
  groupListData: any;

  helper = inject(HelperService);
  usersService = inject(UsersService);
  cookieService = inject(CookieService);
  private toastService = inject(ToastService);
  scrollHeight: string;
  selectedGroups: any[];
  filteredUsers: User[];
  searchText: any='';
  userPayload: { start: string; search: any; };
  isLoading: boolean=false;
  selectedUser: any;
  isEdit:boolean=false
  isDownloading: boolean = false;

  get userStatus(): boolean {
    return this.user.status === 'active'; // Convert string to boolean
}

set userStatus(value: boolean) {
    this.user.status = value ? 'active' : 'inactive'; // Convert boolean to string
}
  
  ngOnInit(): void {

    this.gropuList();

    this.userList();

    this.designationList();

    //this.designation = [{ name: 'Admin Manager' }, { name: 'Access' }];

    this.gender = [
      { label: "Male", value: 'M' },
      { label: 'Female', value: 'F' },
    ] as DropDown[];

    this.calculateScrollHeight();

  }

  closeUserModal(event:any){
    this.isUserModalVisible=false
    this.userList()
  }

  @HostListener('window:resize', ['$event'])
  onResize($event: any) {
    this.calculateScrollHeight();
  }

  openUserModal(user:any){
    this.isEdit=true
    this.isUserModalVisible=true
    this.selectedUser=user
  }
 

  private calculateScrollHeight() {
    const headerHeight = 220;
    const footerHeight = 50;
    const windowHeight = window.innerHeight;
    this.scrollHeight = `${windowHeight - headerHeight - footerHeight}px`;
  }

  onDataLoaded(data:any){
    this.users=data
    this.users = this.users.map((user: any) => ({
      ...user,
      status: user.status == "active" ? true :false // Convert "active" to true and anything else to false
    }));
  }

  onGroupSearch(event:any){
    this.gropuList(event?.filter)
  }

  removeGroup(index: number) {
    this.selectedGroups.splice(index, 1);
  }
  

  gropuList(search?:any) {
    const payload = { "type": "all", "link": "all" ,search};
    this.usersService.getGroups(payload).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          this.groupListData = parsedData.data || [];

          const group = parsedData.data || [];

          this.groupListData = [...group.chapter.standalone, ...group.cluster.standalone, ...group.function.standalone];

        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.log('Error fetching users', error);
      }
    );
  }
  userUrl:string=`${environment.opbBackendHost}/api/admin/user/list`;
  userList(search?:any) {
    this.isLoading=true
    const currentSelection: any = this.user.manager;
    this.userPayload = { start: "0" ,search:this.searchText || search};
    this.usersService.getUsers(this.userPayload).subscribe(
      (data: any) => {
        try {
          this.isLoading=false

          const parsedData = data;
          this.users = parsedData.data || [];
          this.users = this.users.map((user: any) => ({
            ...user,
            status: user.status == "active" ? true :false // Convert "active" to true and anything else to false
          }));
          

          this.manager = parsedData.data || [];


          if (
            currentSelection &&
            !this.manager?.find(
              (item: any) => item?.user_id == currentSelection?.user_id
            )
          ) {
            this.manager.push(currentSelection);
          }
        } catch (error) {
          this.isLoading=false

          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  designationList(search?:any) {
    const designationPayload = { search};
    const currentSelection: any = this.user.designation;

    this.usersService.getDesignations(designationPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const des_array: any[] = [];
          const gender_array = [];
          for (const item of parsedData.data) {
            des_array.push({ label: item?.designation || null, value: item?.designation  || null});
          }
          this.designations = des_array || [];
          if (
            currentSelection &&
            !this.designations?.find(
              (item: any) => item?.value === currentSelection?.value
            )
          ) {
            this.designations.push(currentSelection);
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  userIELList(selectedUser: User) {
    const ielPayload = { "user_id":selectedUser.user_id };
    this.usersService.getIelGroup(ielPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          const iel_array: any[] = [];
          for (const item of parsedData.data) {
            const newData=this.groupListData.filter((items:any) => items.group_id === item.group_id);
            iel_array.push(...newData);

          }
          this.selectedGroups = iel_array || [];
          //this.selectedGroups=parsedData;
          
          if(this.selectedGroups.length>0){
            this.is_iel=true;
          }
          this.visible = true;
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  onIsIelChange(event: boolean): void {
    // if (!this.formGroup.contains('spocuser')) {
    //   // Add the spocuser field if not already present
    //   this.formGroup.addControl('spocuser', this.fb.control(this.selectedSpocuser, Validators.required));
    // }
  }
addUserModal(){
  this.isUserModalVisible=true
  this.isEdit=false

}

  addUser() {
    this.selectedGroups=[]
    this.visible = true;
    this.is_iel=false
    this.user = {
      user_id: '',
      email: '',
      name: '',
      gender: {
        label: '',
        value: ''
      },
      designation: null,
      manager_object_id: '',
      manager_id: '',
      groups: [],
      manager:null
      // manager: {
      //   user_id: '',
      //   name: '',
      //   email: '',
      //   gender: '',
      //   avatar: '',
      //   designation: '',
      //   manager_id: '',
      //   is_admin: '',
      //   is_affiliate: '',
      //   groups: [],
      //   status: 'active'
      // }
    };
  }

  onManagerSearch(event:any){
    this.userList(event.filter)
  }

  onDesignationSearch(event:any){
    this.designationList(event.filter)
  }

  addData(form: NgForm) {
    if (form.valid) {
      const userData = {
        "name": form.value.name,
        "email": form.value.email,
        "designation": form.value.designation.value,
        "gender": form.value.gender.value,
        "is_admin": "yes",
        "is_affiliate": "no",
        "manager_id": form.value.manager?.user_id
      }

      const userDataPayload = { ...userData };

      this.usersService.addUsers(userDataPayload).subscribe(
        (data: any) => {
          try {
            const parsedData = data;
            if (parsedData.error) {
              //alert(parsedData.message)
              this.toastService.error(parsedData.message)
            } else {
             // alert(parsedData.message)
              this.toastService.success(parsedData.message)
              this.visible = false;
            }

          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
        },
        (error) => {
          console.error('Error fetching users', error);
        }
      );


      if (form.value.groups.length) {
        const ielData = {
          "user_id": form.value.manager?.user_id,
          "groups": form.value.groups.map((item: any) => item.group_id).join(', ')
        }

        const ielPayload = { ...ielData };

        this.usersService.addIelGroup(ielPayload).subscribe(
          (data: any) => {
            try {
              const parsedData = data;
              if (parsedData.error) {
                // alert(parsedData.message)
                this.toastService.error(parsedData.message)
              } else {
                // alert(parsedData.message)
                this.toastService.success(parsedData.message)
                this.visible = false;
              }

            } catch (error) {
              console.error('Error parsing decoded data:', error);
            }
          },
          (error) => {
            console.error('Error fetching users', error);
          }
        );

      }

    }
  }

  updateData(form: NgForm) {
    if (form.valid) {
      const formData = {
        "user_id": this.user.user_id,
        "name": form.value.name,
        "email": form.value.email,
        "designation": form.value.designation.value,
        "gender": form.value.gender.value,
        "is_admin": this.user.is_admin === true ? "yes" : "no",
        "is_affiliate": this.user.is_affiliate === true ? "yes" : "no",
        "manager_id":  this.user.user_id
      }


      this.usersService.updateUsers(formData).subscribe(
        (data: any) => {
          try {
            const parsedData = data;
            if (parsedData.error) {
              this.toastService.error(parsedData.message)
            } else {
              this.toastService.success(parsedData?.message);
              this.visible = false;
              this.userList();
            }

          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
        },
        (error) => {
          console.error('Error fetching users', error);
        }
      );


      if (form.value.groups?.length) {
        const ielData = {
          "user_id": form.value.manager?.user_id,
          "groups": form.value.groups.map((item: any) => item.group_id).join(', ')
        }

        this.usersService.addIelGroup(ielData).subscribe(
          (data: any) => {
            try {
              const parsedData = data;
              if (parsedData.error) {
                // alert(parsedData.message)
                this.toastService.error(parsedData.message)
              } else {
                // alert(parsedData.message)
                this.toastService.success(parsedData.message)
                this.visible = false;
              }

            } catch (error) {
              console.error('Error parsing decoded data:', error);
            }
          },
          (error) => {
            console.error('Error fetching users', error);
          }
        );

      }


    }
  }

  deleteData(selectedUser: User) {
    const formData = {
      "user_id": selectedUser.user_id,
    }
    const userDataPayload = { formData };

    this.usersService.deleteUser(userDataPayload).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          if (parsedData.error) {
            alert(parsedData.message)
          } else {
            alert(parsedData.message)
            this.userList();
          }

        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error delete users', error);
      }
    );

  }

  changeStatus(selectedUser: User, newStatus: boolean) {
    
    const formData = {
        "user_id": selectedUser.user_id,
        "status": newStatus ? "active" : "inactive"  // Toggle status
    };

    this.usersService.changeStatus(formData).subscribe(
        (data: any) => {
            try {
                if (data.error) {
                    this.toastService.error(data.message);
                } else {
                  this.toastService.success(data.message);
                  this.userList()
                  // this.userList();  // Refresh user list
                }
            } catch (error) {
                console.error('Error parsing decoded data:', error);
            }
        },
        (error) => {
            console.error('Error changing user status', error);
        }
    );
}

  getGroupNames(groups: any[]): string {
    return groups.map(g => g?.group?.name).join(', ');
  }

  filterUsers() {
   this.userList()
  }
  
  exportUsers() {
    this.isDownloading = true;
    const reqData = {
      responseType: 'blob',
    };

    this.usersService.downloadUsers(reqData).subscribe(
      (data: Blob) => {
        this.isDownloading = false;
        const blob = new Blob([data], { type: data.type });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'users.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.toastService.success('File downloaded successfully');
      },
      (error) => {
        this.isDownloading = false;
        console.error('Error fetching template:', error);
      }
    );
  }

  closeModal(): void {
    this.visible = false;
  }

}